export class AddWallAction {
  constructor(
    public readonly wallUuid: string
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/AddWallAction.ts